export default __webpack_public_path__ + "static/media/023-polka dot.9fbf4698.svg";